import type * as React from 'react';

const HomePage = () : React.ReactElement => {
    return (
        <>
            Nothing to see here.
        </>
    );
};

export default HomePage;
